// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'


import login from '../components/login/login.vue'
import signup from '../components/login/signup.vue'


import home from '../components/home.vue'


import checkIn from '../components/checkIn.vue'


import campus from '../components/courseArrange/campus.vue'
import teacherAndCourse from '../components/courseArrange/teacherAndCourse.vue'
import teacherFee from '../components/courseArrange/teacherFee.vue'
import vacation from '../components/courseArrange/vacation.vue'
import courseArrange from '../components/courseArrange/courseArrange.vue'
import publishCourse from '../components/courseArrange/publishCourse.vue'
import operationLog from '../components/courseArrange/operationLog.vue'


import enrollment from '../components/enrollAndClear/enrollment.vue'
import studentManagement from '../components/enrollAndClear/studentManagement.vue'
import paymentRecords from '../components/enrollAndClear/paymentRecords.vue'


import financialDashboard from '../components/finance/financialDashboard.vue'
import withdraw from '../components/finance/withdraw.vue'
import refundApproval from '../components/finance/refundApproval.vue'
import consultantPerformance from '../components/finance/consultantPerformance.vue'


import courseStatistics from '../components/courseStatistics.vue'


import peopleManagement from '../components/peopleManagement.vue'


import test from '../test.vue'


import uploadFile from '../components/1test/uploadFile.vue'
import exam from '../components/1test/exam.vue'


const routes = [
    {
        path: '/',
        redirect: "/home"
    },

    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/signup',
        name: 'signup',
        component: signup
    },


    {
        path: '/home',
        name: 'home',
        component: home
    },

    
    {
        path: '/checkIn',
        name: 'checkIn',
        component: checkIn
    },


    {
        path: '/campus',
        name: 'campus',
        component: campus
    },
    {
        path: '/teacherAndCourse',
        name: 'teacherAndCourse',
        component: teacherAndCourse
    },
    {
        path: '/teacherFee',
        name: 'teacherFee',
        component: teacherFee
    },
    {
        path: '/vacation',
        name: 'vacation',
        component: vacation
    },
    {
        path: '/courseArrange',
        name: 'courseArrange',
        component: courseArrange
    },
    {
        path: '/publishCourse',
        name: 'publishCourse',
        component: publishCourse
    },
    {
        path: '/operationLog',
        name: 'operationLog',
        component: operationLog
    },


    {
        path: '/enrollment',
        name: 'enrollment',
        component: enrollment
    },
    {
        path: '/studentManagement',
        name: 'studentManagement',
        component: studentManagement
    },
    {
        path: '/paymentRecords',
        name: 'paymentRecords',
        component: paymentRecords
    },


    {
        path: '/financialDashboard',
        name: 'financialDashboard',
        component: financialDashboard
    },
    {
        path: '/withdraw',
        name: 'withdraw',
        component: withdraw
    },
    {
        path: '/refundApproval',
        name: 'refundApproval',
        component: refundApproval
    },
    {
        path: '/consultantPerformance',
        name: 'consultantPerformance',
        component: consultantPerformance
    },


    {
        path: '/courseStatistics',
        name: 'courseStatistics',
        component: courseStatistics
    },


    {
        path: '/peopleManagement',
        name: 'peopleManagement',
        component: peopleManagement
    },


    {
        path: '/test',
        name: 'test',
        component: test
    },

    {
        path: '/uploadFile',
        name: 'uploadFile',
        component: uploadFile
    },
    {
        path: '/exam',
        name: 'exam',
        component: exam
    },


]

const router = createRouter({
    history: createWebHistory(),
    routes
})


// 无需登录的url
let arr = ["login", "signup", "uploadFile", "exam", "test"]
// 路由守卫
router.beforeEach((to, from, next) => {
  // 用户信息存储在 sessionStorage 中
  const isUserLoggedIn = sessionStorage.getItem('userInfo');

  // 如果用户未登录且尝试访问非登录页面，则重定向到登录页
  if (!isUserLoggedIn && !arr.includes(to.name)) {
    console.log("\nunlogin, redirect to /login")
    next({ name: 'login' });


  } else {
    next(); // 否则，继续路由
  }
});


export default router